import {
  DataAttributeDefinitions,
  currentUser,
  load,
  provideDataItem
} from "scrivito"
import {
  UpdateNeoletterUserProfileDocument,
  UpdateNeoletterUserProfileMutation,
  UpdateNeoletterUserProfileMutationVariables
} from "shared/api/neoletter-user-profile/mutation.generated"
import {
  NeoletterUserProfileDocument,
  NeoletterUserProfileQuery,
  NeoletterUserProfileQueryVariables
} from "shared/api/neoletter-user-profile/queries.generated"
import { Logger } from "shared/lib/Logger"
import { ensureString } from "shared/lib/ensureString"
import { PisaUser } from "shared/types/UserInfo"
import { NeoletterUserProfile } from "shared/types/__generated__/graphql"

import { apolloClient } from "app/apolloRestLink"
import personCircle from "assets/images/person-circle.svg"

import I18n from "i18n"

import "../User/UserDataClass"

// import { getPisaClient } from "../pisaClient"

async function attributes(): Promise<DataAttributeDefinitions> {
  return {
    company: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.company.title") }
    ],
    email: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.email.title") }
    ],
    familyName: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.familyName.title") }
    ],
    givenName: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.givenName.title") }
    ],
    jrUserId: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.salesUserId.title") }
    ],
    name: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.name.title") }
    ],
    phoneNumber: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.phoneNumber.title") }
    ],
    picture: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.picture.title") }
    ],
    pisaUserId: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.pisaUserId.title") }
    ],
    salesUserId: [
      "reference",
      {
        to: "User",
        title: I18n.t("editing:attributes.CurrentUser.salesUserId.title")
      }
    ],
    salutation: [
      "string",
      { title: I18n.t("editing:attributes.CurrentUser.salutation.title") }
    ],
    neoletterUserId: [
      "string",
      {
        title: I18n.t("editing:attributes.CurrentUser.neoletterUserId.title")
      }
    ],
    serviceUserId: [
      "reference",
      {
        to: "User",
        title: I18n.t("editing:attributes.CurrentUser.salesUserId.title")
      }
    ]
  }
}

export const CurrentUser = provideDataItem("CurrentUser", {
  attributes,
  connection: {
    async get() {
      const user = await load(currentUser)
      if (!user) return null

      let neoletterProfile: NeoletterUserProfile | null | undefined
      try {
        neoletterProfile = await apolloClient
          .query<NeoletterUserProfileQuery, NeoletterUserProfileQueryVariables>(
            { query: NeoletterUserProfileDocument }
          )
          .then(result => result.data.neoletterUserProfile)
      } catch (error) {
        if (error instanceof Error) {
          Logger.error(error, "failed to fetch neoletter profile")
        } else {
          Logger.error("UnknownError", "failed to fetch neoletter profile")
        }
      }

      // const client = await getPisaClient("whoami")

      const pisaUser: PisaUser | undefined = undefined as PisaUser | undefined

      // : PisaUser | undefined = (await client?.get("")) as
      //   | PisaUser
      //   | undefined

      return {
        email: user.email(),
        picture: user.picture() || personCircle,
        jrUserId: user.id(),
        neoletterUserId: neoletterProfile?.id,

        pisaUserId: pisaUser?._id,
        salesUserId: pisaUser?.salesUserId,
        serviceUserId: pisaUser?.serviceUserId,

        name: ensureString(neoletterProfile?.name),
        company: ensureString(neoletterProfile?.company),
        familyName: ensureString(neoletterProfile?.family_name),
        givenName: ensureString(neoletterProfile?.given_name),
        phoneNumber: ensureString(neoletterProfile?.phone_number),
        salutation: ensureString(neoletterProfile?.salutation)
      }
    },
    async update(params) {
      const { salutation, name, phoneNumber, company } = params
      try {
        await apolloClient.mutate<
          UpdateNeoletterUserProfileMutation,
          UpdateNeoletterUserProfileMutationVariables
        >({
          mutation: UpdateNeoletterUserProfileDocument,
          variables: {
            input: {
              name: ensureString(name),
              salutation: ensureString(salutation),
              phone_number: ensureString(phoneNumber),
              company: ensureString(company)
            }
          }
        })
      } catch (error) {
        if (error instanceof Error) {
          Logger.error(error, "failed to update neoletter profile", { params })
        } else {
          Logger.error("RequestError", "failed to update neoletter profile", {
            params
          })
        }
      }
    }
  }
})
